import { render, staticRenderFns } from "./AssetControlPicker.vue?vue&type=template&id=06003528&"
import script from "./AssetControlPicker.vue?vue&type=script&lang=js&"
export * from "./AssetControlPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports